import React, {useEffect, useState} from 'react';
import {supabase} from '../../services/supabase.service'
import PageHeader from '../../components/PageHeader';
import {DataGrid, GridColDef, GridToolbar} from '@material-ui/data-grid';
import {useParams} from "react-router-dom";
import {Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@material-ui/core';

import './styles.css';
import Select from "../../components/Select";

function Dashboard() {
    const [editions, setEditions] = useState<any[]>([]);
    const [evaluations, setEvaluations] = useState<any[]>([]);
    const [evaluationSelected, setEvaluationSelected] = useState<any>(false);
    const [columns_eval, setColumns_eval] = useState<GridColDef[]>();
    const [user, setUser] = useState<any>({email: 'fabioweydson@gmail.com', password: '123456'});
    // @ts-ignore
    const { id } = useParams();
    const columns: GridColDef[] = [
        {field: 'id', headerName: 'ID', flex: 0.3, hide: true},
        {
            field: 'group_id', headerName: 'Grupo', flex: 0.4, sortable: false,
            valueGetter: (params: any) => {
                return params.row.student.group_id;
            }
        },
        {
            field: 'name', headerName: 'Nome', flex: 1, sortable: false,
            valueGetter: (params: any) => {
                return params.row.student.name;
            }
        },
        // {field: 'progresso', headerName: 'Progresso', flex: 0.5},
        {
            field: 'nota', headerName: 'Media', flex: 0.7, valueGetter: ((params: any) => {
                console.log(params.row.nota, params.row.num_evaluators)
                return parseFloat((params.row.nota / (params.row.num_evaluators * 3)).toFixed(1));
            })
        },
        {
            field: 'votes', headerName: 'Avaliadores', flex: 0.7, renderCell: ((params: any) => {
                return <Chip size="small" color="default" style={{fontSize: `14px`}} label={params.row.num_evaluators}/>
            })
        },
        {
            field: 'turma', headerName: 'Turma', flex: 0.7, sortable: false,
            valueGetter: (params: any) => {
                let meta_data = params.row.student.metadata || '[]';
                return `${meta_data.turma ? meta_data.turma : ''}`;
            }
        },
        {
            field: 'grupo', headerName: 'Grupo', flex: 0.5, sortable: false,
            valueGetter: (params: any) => {
                return `${params.row.student.group_id ? params.row.student.group_id : ''}`;
            }
        },
        // {
        //     field: 'progresso', headerName: 'Progresso', flex: 0.5,
        //     valueGetter: (params: any) => {
        //         let meta_data = JSON.parse(params.row.metadata || '[]') || [];
        //         return `${meta_data.progress ? meta_data.progresso : 0}%`;
        //     }
        // },
        {
            field: 'acoes', headerName: 'Açoes', flex: 0.5, sortable: false,
            renderCell: (params: any) => {
                return <Button color="primary"
                               onClick={() => EvaluationDetails(params.row.student_id, params.row.edition)}>Detalhes</Button>;
            }
        }
    ];

    const EvaluationDetails = async (studentId: any, editionId: any) => {
        const {data} = await supabase
            .from('evaluations')
            .select(`*, 
                avaliador:evaluators(name)`)
            .eq('student_id', studentId)
            .eq('edition', editionId)
        if (data && data.length > 0)
            setEvaluationSelected(data)
        return
    }


    async function getEvaluations(id:any) {
        console.log('id', id)
        const {data} = await supabase
            .from('evaluations')
            .select(`
          *, 
          student:eval_students(name, monitora, metadata, group_id),
          evaluator:evaluators(name,email)`)
            .eq('edition', id).limit(5000)

        const new_evals:any = {};

        if (data && data.length)
            data.map((e:any) => {
                if (e.student_id in new_evals) {

                    let nota = parseInt(new_evals[e.student_id]["nota"] || 0);

                    let totalEvals = (new_evals[e.student_id]['evaluators'].includes(e.evaluatorid)) ? new_evals[e.student_id]['num_evaluators'] : new_evals[e.student_id]['num_evaluators'] + 1;

                    let newStudent =
                        {
                            ...e,
                            "num_evaluators": totalEvals,
                            "nota": nota + e.evaluation,
                            "evaluators": [...new Set([...new_evals[e.student_id]["evaluators"], e.evaluatorid])]
                        }
                    new_evals[e.student_id] = newStudent;
                } else {

                    new_evals[e.student_id] = {
                        ...e,
                        "num_evaluators": 1,
                        "nota": e.evaluation,
                        "evaluators": [e.evaluatorid]
                    }
                }
                return e
            })

        setEvaluations(Object.values(new_evals) || []);
        console.log("new_evals", Object.values(new_evals))

        setColumns_eval([
            {field: 'id', headerName: 'ID', flex: 0.1, hide: true},
            {
                field: 'avaliador', headerName: 'Avaliador', flex: 0.4, sortable: false,
                valueGetter: (params: any) => params.row.avaliador.name
            },
            {field: 'evaluation', headerName: 'Nota', flex: 0.3, sortable: false},
            {
                field: 'comment', headerName: 'Comentário', flex: 1, sortable: false,
                valueGetter: (params: any) => (params.row.comment || 'Nenhum comentario')
            }
        ])
    }

    async function doLogin() {
        const {data:user_data} = await supabase.from('admin').select('*')
            .eq('email', user.email)
            .eq('pass', user.password)
        if(user_data && user_data.length > 0) {
            window.localStorage.setItem('admin', JSON.stringify(user_data[0]))
            await getEvaluations(id);
        }
        console.log(user_data)
    }

    async function getEditions() {
        const {data} = await supabase
            .from('editions')
            .select('*')
        console.log("data", data)
        if(data && data.length > 0) {
            console.log(data)
            let editions_options = data.map((e: any) => {
                return {
                    value: e.edition_number,
                    label: e.title
                }
            })
            setEditions(editions_options)
        }
    }


    useEffect(() => {
        (async () => await getEditions())();
        if(id) {
            (async () => await doLogin())();
        }
    }, [id])


    function setId(value: string) {
        let edition_selected = editions.find((e) => e.value == value)
        console.log(value, editions, edition_selected)
        window.location.href = `/dashboard/${value}/${edition_selected.label.toLowerCase().trim().replace(/ /g, '-')}`
    }

    return (
        <>
            <div id="page-teacher-list" className="main">
                <PageHeader title="Relatório de avaliações">
                    <Select options={editions} value={id} onChange={(e) => setId(e.target.value as string)} label="" name="edicao">
                    </Select>
                </PageHeader>
                <Grid container style={{marginTop: 50, marginBottom: 50, minHeight: 400}} justifyContent="center">
                    {/*<Grid item lg={12} md={12}>*/}
                    {/*    <LoginForm doLogin={doLogin}/>*/}
                    {/*</Grid>*/}
                    <Grid item md={11} lg={11} sm={12} xs={12} style={{backgroundColor: '#FFF'}}>
                        {evaluations &&
                            <DataGrid pageSize={15}
                                      autoHeight
                                      density="compact"
                                      disableSelectionOnClick
                                      components={{
                                          Toolbar: GridToolbar,
                                      }}
                                      rows={evaluations} columns={columns}/>
                        }
                    </Grid>
                </Grid>
                {evaluationSelected && columns_eval &&
                    <Dialog open={(evaluationSelected.length > 0)} maxWidth={"md"}
                            onClose={() => setEvaluationSelected(false)}
                            style={{background: 'rgba(0,0,0,0.11)'}}>
                        <DialogTitle id="scroll-dialog-title">Avaliações</DialogTitle>
                        <DialogContent>
                            <Grid id="avaliacoes" container style={{width: '700px'}}>
                                <Grid item md={12} xs={12} lg={12} sm={12}>
                                    <DataGrid columns={columns_eval} autoHeight rows={evaluationSelected}
                                              pageSize={15}/>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setEvaluationSelected(false)}>Fechar</Button>
                        </DialogActions>
                    </Dialog>
                }
            </div>
        </>
    )
}


export default Dashboard;
